import orderBy from "lodash/orderBy";
export default function sort(items, sortBy, sortOrder) {
    return sortBy && sortOrder ? orderBy(items, [sortBy], [sortOrder]) : items;
}
